import { clientStore } from "../store/clientStore";

/**
 * Opens the document a link field points at (`?d=<documentId>&id=<entryId>&v=<moduleId>`).
 *
 * The link names only the document, and the legacy viewer refuses an htmljs one ("cannot be opened
 * through the legacy document viewer"). GET /doc/manifest says which engine renders it - with the
 * same document rights and stage gate as /doc/data - so an htmljs document opens in its own viewer.
 * A legacy document, or any failure to ask, keeps the payload the link always sent.
 */
export async function openDocumentLink({ d, id, v }) {
  let document = { id: d, typeId: "pdf" };
  try {
    const res = await clientStore.dispatch("docManifest", { moduleId: v, documentId: d });
    const manifest = res && res.data;
    if (manifest && manifest.engine === "htmljs") document = manifest;
  } catch (e) {
    // Not reachable or not accessible: the legacy path reports its own error, as before.
  }
  window.eventBus.$emit("showPDFDocument", {
    document,
    items: [{ id }],
    moduleId: v,
  });
}

export default { openDocumentLink };
